import { Component, input } from "@angular/core";
import { FieldTree, FormField } from "@angular/forms/signals";
import { BusinessAttributes } from "../user/business-attributes";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-business-profile-input",
    imports: [FormField, TranslateModule],
    templateUrl: "./business-profile-input.component.html",
    styleUrl: "./business-profile-input.component.scss",
})
export class BusinessProfileInputComponent {
    readonly businessProfileInput = input.required<FieldTree<BusinessAttributes>>();
}
